import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { IAddCustomStreamLinkRequest, IEditCustomStreamLinkRequest } from "./request.types";
import type { TCustomStream, TGetCustomStreamListResponse } from "./response.types";

class CustomStreamController extends Controller {
	public constructor() {
		super({ requestUrl: "models/custom-stream" });
	}

	/**@GET CUSTOM STREAM LINKS */
	public async getCustomStreamLinksAsync({ token }: IRequestConfig) {
		return this.get<TGetCustomStreamListResponse>("base", "", { token });
	}

	/**@POST ADD CUSTOM STREAM LINK */
	public async addCustomStreamLinkAsync({ token, links, title }: IAddCustomStreamLinkRequest) {
		return this.post<TCustomStream>("", { links, title }, { token });
	}

	/**@PUT EDIT CUSTOM STREAM LINK */
	public async editCustomStreamLinkAsync({ token, id, links, title }: IEditCustomStreamLinkRequest) {
		return this.put<Omit<TCustomStream, "id">>(`/${id}`, { links, title }, { token });
	}

	/**@DELETE DELETE CUSTOM STREAM LINK */
	public async deleteCustomStreamLinkAsync({ token, id }: IRequestConfig & { id: number }) {
		return this.delete<{ status: string }>(`/${id}`, { token });
	}
}

export const customStreamAPI = new CustomStreamController();
